import { render } from "./Recruitment.root.vue?vue&type=template&id=5d8b0ba8"
import script from "./Recruitment.root.vue?vue&type=script&lang=js"
export * from "./Recruitment.root.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__